import React from 'react'
import { useField } from 'formik'
import LabeledPrimaryCheckbox from 'components/Shared/LabeledPrimaryCheckbox/LabeledPrimaryCheckbox'

export default function LabeledCheckboxField ({ fieldName, label, disabled, className }) {
  const [, { value }, { setValue }] = useField(fieldName)

  return <div className={className}>
    <LabeledPrimaryCheckbox label={label}
                            name={fieldName}
                            value={true}
                            disabled={disabled}
                            checked={value || false}
                            onChange={e => setValue(e.target.checked)}/>
  </div>
}
